import { render, staticRenderFns } from "./ClassTimetableTable.vue?vue&type=template&id=28ba2861"
import script from "./ClassTimetableTable.vue?vue&type=script&lang=js"
export * from "./ClassTimetableTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports